import React  from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";

const DeletePackageDialog = (props) => {
    const { t } = props;
    return (
      <BaseDialog
        show={props.show}
        onHide={props.onHide}
        size="xs"
        title={t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Title")}
        dialogApiError={props.dialogApiError}
        rightButtonCallback={() => props.onSubmit()}
        rightButtonDisabled={props.isRunning}
        rightButtonText={
        props.isRunning ? (
            <><FontAwesomeIcon icon={faCircleNotch} spin /> {t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Confirm")}</>
        ) : t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Confirm")}
        rightButtonVariant="red"
        leftButtonCallback={props.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        body={(<p>
          {t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Text", {
            packageName: props.name
          })}
        </p>)}
      />
    );
}

export default withTranslation()(DeletePackageDialog);
